import { FileField_default } from "./chunk-2WFFV4FB.js";
import { FileInput_File_default } from "./chunk-HX2QF5T3.js";

// src/components/FileField/index.tsx
var FileFieldComponent = FileField_default;
FileFieldComponent.File = FileInput_File_default;
FileFieldComponent.File.displayName = "FileField.File";
export { FileFieldComponent };